



import React, { useEffect, useState } from "react";
import { BsFacebook, BsInstagram } from "react-icons/bs";
import { FaUserEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import BrandHeader from "./BrandHeader"; // Assuming BrandHeader is the header component
import Navbar from "./Navbar"; // Import the Navbar componentsss
import '../../App.css';

const BrandProfile = () => {
  const navigate = useNavigate();
  const [brandData, setBrandData] = useState({});
  const [loading, setLoading] = useState(true);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const getBrandData = async () => {
    try {
      const brandId = localStorage.getItem("brandID");
      if (!brandId) {
        console.log("Brand ID not found in localStorage");
        return;
      }
      const response = await fetch(`https://server-side-influencer.onrender.com/brand/getBrandData/${brandId}`);
      const data = await response.json();
      setBrandData(data.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getBrandData();
  }, []);

  const editProfile = () => {
    navigate('/BrandProfileEdit', { state: brandData });
  };
  
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 720);
    };

    handleResize(); // Check initial sizess
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <div className="flex h-screen mb-0    justify-center items-center w-full page-scroll">
    {/* Navbar with higher z-index */}
    <div className="text-white fixed top-0 left-0 bottom-0 z-50">
      <Navbar />
    </div>

      <div className="h-screen ml-0 w-full">
        {/* Brand Header */}
        <BrandHeader page="Brand Profile" />

        {/* Profile Background and Pictures */}
        <div className="relative h-96 w-full bg-gray-200 flex justify-center items-center mb-6" style={{ marginBottom: '100px' }}>
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${brandData.brandbackgroundimage2 || 'https://i.postimg.cc/QM0NNSx2/dummyd.png'})` }}></div>
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>
          <div className="absolute bottom-[-50px] flex flex-col items-center">
            {/* <img
              className="w-28 h-28 rounded-full border-4 border-white shadow-lg object-cover"
              src={brandData.brandbackgroundimage || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"}
              alt="Profile"
            /> */}
              <img
      className="w-28 h-28 rounded-full border-4 border-white shadow-lg object-cover"
      src={brandData.brandbackgroundimage || "https://i.postimg.cc/brqZVdrP/dummypic.jpg"}
      alt="Profile"
      style={{ objectPosition: 'center center' }}  
    />
            <a
              onClick={editProfile}
              className="absolute bottom-0 right-0 bg-white p-1 rounded-full shadow-md cursor-pointer"
            >
              <FaUserEdit className="text-gray-600" size={20} />
            </a>
          </div>
        </div>

        {/* Brand Info Boxs */}
        <div className="px-8 py-12 bg-white rounded-t-2xl shadow-lg text-center w-3/4 mx-auto " style={{ marginTop: '50px', marginBottom: '0px' ,marginLeft:  isSmallScreen ?'50px':'230px' }}>
          <div className="grid grid-cols-2 gap-4 text-left justify-center mx-auto w-full max-w-lg">
            <p className="text-xs sm:text-sm md:text-base"><strong>Brand Name:</strong> {brandData.shopName || "N/A"}</p>
              <p className="text-xs sm:text-sm md:text-base"><strong>Full Name:</strong> {brandData.uname || "N/A"}</p>
            <p className="text-xs sm:text-sm md:text-base"><strong>Brand Type:</strong> {brandData.brandType || "N/A"}</p>
            <p className="text-xs sm:text-sm md:text-base"><strong>Phone:</strong> {brandData.phone || "N/A"}</p>
            <p className="text-xs sm:text-sm md:text-base" style={{ wordBreak: 'break-word' }}><strong>Email:</strong> {brandData.email || "N/A"}</p> {/* Apply wordBreak here */}
            <p className="text-xs sm:text-sm md:text-base"><strong>Location:</strong> {brandData.location || "N/A"}</p>
            <p className="text-xs sm:text-sm md:text-base"><strong>Description:</strong> {brandData.description || "N/A"}</p>
            <p className="text-xs sm:text-sm md:text-base"><strong>Socials:</strong></p>
            <p className="text-xs sm:text-sm md:text-base flex items-center space-x-2">
              <a target="_blank" href={brandData.facebookUrl} title="Facebook"><BsFacebook size={20} color="#3b5998" /></a>
              <a target="_blank" href={brandData.instagramUrl} title="Instagram"><BsInstagram size={20} color="#E1306C" /></a>
              {/* <a target="_blank" href={brandData.twitterUrl} title="Twitter"><BsYoutube size={20} color="#FF0000" /></a> */}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandProfile;




